import { ownerConstants } from "./owner.constants";
import { ownerService } from "services";

export const ownerActions = {
	sendOwner,
};

function sendOwner(payload) {
	return (dispatch) => {
		dispatch(request());
		return ownerService
			.sendOwner(payload)
			.then(
				result => {
					dispatch(success());
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};

	function request() {
		return {
			type: ownerConstants.SEND_OWNER_REQUEST,
		};
	}

	function success() {
		return {
			type: ownerConstants.SEND_OWNER_SUCCESS,
		};
	}

	function failure(error) {
		return {
			type: ownerConstants.SEND_OWNER_ERROR,
			error,
		};
	}
}
